// Autogenerated file
export const driverSalaryMileageTypesEnum = {
    Plan: "Plan",
    Overall: "Overall",
    ActiveAndEmpty: "ActiveAndEmpty",
};
export const driverSalaryMileageTypes = [
    { label: "Плановый", value: "Plan" },
    { label: "Фактический общий", value: "Overall" },
    { label: "Фактический активный/фактический порожний", value: "ActiveAndEmpty" },
];
